import { createAction, createFeatureSelector, createReducer, on, props } from '@ngrx/store';
export interface LocalizationState<AppLanguage = string> {
  language: AppLanguage;
}

export const initialState: LocalizationState = {
  language: 'en',
};
export const SetLanguage = createAction(
  '[Language] set',
  props<{ language: string; init?: boolean }>(),
); // TODO: load general data in effect

export const selectLocalization =
  createFeatureSelector<LocalizationState>('localization');

export const LocalizationReducer = createReducer(
  initialState,
  on(SetLanguage, (_, { language }) => ({
    ..._,
    language,
  })),
);
